module.exports = __webpack_public_path__ + "static/media/0040.47dac224.png";